import DataTable from "../../components/DataTable/DataTable";
import {useState} from "react";
import http from "../../http";
import {Button, message, Space, Tooltip, Typography} from "antd";
import APIServerAddPage from "./APIServerAddPage";
import {EditOutlined, PlusOutlined} from "@ant-design/icons";


const APIServerListPage = () => {
    const [showModal, setShowModal] = useState(false);
    const [reload, setReload] = useState(false);
    const [edit, setEdit] = useState(false);
    const [item, setItem] = useState(false);
    const handleOpenModal = (item, edit) => {
        if(edit){
            setEdit(true);
            setItem(item);
            setShowModal(true);
        }
        else {
            setEdit(false);
            setItem(null);
            setShowModal(true);

        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEdit(false);
        setItem(null);
    };
    const handleSuccessAdd = () =>{
        setShowModal(false);
        setEdit(false);
        setItem(null);
        setReload(!reload);
    }

    const handleDeleteClick = (item)=>{
        http.delete(`/api/v1/api_service/api_servers/${item.id}/delete/`).then((resp)=>{
            setReload(!reload);
        }).catch((err)=>{
            if(err.response){
                message.error(err.response.data.message);
            }
        })
    }
    const renderEditIcon=(record)=>{
        // if(!record.status){
            return <Typography.Link onClick={()=>handleOpenModal(record, true)}><EditOutlined /></Typography.Link>
        // }
        // return <Typography.Link style={{color:'grey'}} onClick={()=>message.error('Can\'t be edited this item')}><EditOutlined /></Typography.Link>
    }
    const columns = [
        {
            title: 'Server',
            dataIndex: 'name',
            key: 'server_name',
            width: '9%'
        },
        {
            title: 'Domain',
            dataIndex: 'server_domain',
            key: 'server_domain',
            width: '9%',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
        {
            title: 'IP',
            dataIndex: 'server_ip',
            key: 'server_ip',
            width: '9%',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
        {
            title: 'Token URL',
            dataIndex: 'token_url',
            key: 'token_url',
            width: '9%',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
        {
            title: 'Login URL',
            dataIndex: 'login_url',
            key: 'login_url',
            width: '9%',
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
        {
            title: 'Auth App',
            dataIndex: 'app_name',
            key: 'app_name',
            width: '9%',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
        {
            title: 'Client ID',
            dataIndex: 'client_id',
            key: 'client_id',
            width: '9%',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
        {
            title: 'Client Secret',
            dataIndex: 'client_secret',
            key: 'client_secret',
            width: '9%',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
        {
            title: 'Username',
            dataIndex: 'api_username',
            key: 'api_username',
            width: '9%',
        },
        {
            title: 'Password',
            dataIndex: 'api_password',
            key: 'api_password',
            width: '9%',
        },
        {
            title: 'Action',
            key: 'action',
            fixed:'right',
            width: '10%',
            align: 'center',
            render: (record) => (
                <Space size="middle">
                    {renderEditIcon(record)}
                </Space>
            )
        },
    ];

    const searchFields = [
        {
            name: 'name',
            type: 'input',
            label: 'Name',
            placeholder: 'Server Name'
        },
        {
            name: 'server_ip',
            type: 'input',
            label: 'IP',
            placeholder: 'Server IP'
        }
    ];

    const data = [
        // Provide your table data if not using URL
    ];

    return (
        <>
            <DataTable
                reload={reload}
                pageTitle={'API Servers'}
                columns={columns}
                url="/api/v1/api_service/api_servers/"
                searchFields={searchFields}
                pagination={true}
                pageButtons={[
                    <Button
                        type="primary"
                        shape={'circle'}
                        icon={<PlusOutlined/>}
                        style={{marginLeft: 16, background:'#377EF3'}}
                        onClick={()=>handleOpenModal()}
                    />
                ]}
            />
            <APIServerAddPage
                visible={showModal}
                onClose={handleCloseModal}
                onSuccessSubmit={handleSuccessAdd}
                edit={edit}
                editItem={item}
                reload={reload}
            />
        </>
    );
};

export default APIServerListPage;